import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import { AlarmsPDFDocument } from './AlarmsPDFDocument';
import axios from "axios";
import "./styles.css";

// @mui
import {
  Box,
  Card,
  Table,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TableHead
} from '@mui/material';

import Scrollbar from '../components/scrollbar';
import { UserListToolbar } from '../sections/@dashboard/user';

// ----------------------------------------------------------------------

export default function AlarmsListAll() {

  const [showPDF, setShowPDF] = useState(false);
  const [members, setMembers] = useState([]);
  const [dataloaded, setDataLoaded] = useState(false);
  const [selected, setSelected] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);

  const { user: currentUser } = useSelector((state) => state.auth);

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  const [filterName, setFilterName] = useState('');

  useEffect(() => {
    if (!dataloaded) {
      getAllAlarms();
    }
  }, [dataloaded]);

  const getAllAlarms = async () => {
    try {
      const response = await axios.get(SERVER_URL + "/api/alarms");
      setMembers(response.data);
      setDataLoaded(true);
    } catch (err) {
      console.log("error");
    }
  };

  if (!currentUser) return <Navigate to="/login" />;

  const filteredUsers = members.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <Helmet>
        <title> Pametna rasvjeta </title>
      </Helmet>

      <Container
        maxWidth={false}
        sx={{
          backgroundColor: '#001536',
          height: '100%',
          boxSizing: 'border-box',
          padding: '20px'
        }}
      >

        <Typography
          variant="h6"
          sx={{
            p: 2,
            pl: 1,
            color: '#ff9800',
            fontWeight: 600,
            textAlign: "left"
          }}
        >
          Pregled alarma
        </Typography>

        <Card sx={{ backgroundColor: '#00122E' }}>

          <UserListToolbar
            numSelected={selected.length}
            filterName={filterName}
            onFilterName={(e) => setFilterName(e.target.value)}
            sx={{ color: '#ff9800' }}
          />
          <TableContainer sx={{ width: '100%' }}>
            <Table
              sx={{
                width: '100%',
                tableLayout: 'fixed',
                // 🔥 sve ćelije (th + td)
                '& .MuiTableCell-root': {
                  borderBottom: '1px solid #374151',
                },

                // 🔥 header linija (deblja)
                '& .MuiTableCell-head': {
                  color: '#ff9800 !important',
                  borderBottom: '2px solid #374151',
                }
              }}
            >

              {/* 🔥 HEADER UNIFICIRAN */}
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: '#001B44',
                    '& .MuiTableCell-root': {
                      backgroundColor: '#001B44',
                      color: '#ff9800',
                      fontWeight: 700,
                      fontSize: '13px',
                      letterSpacing: '0.5px',
                      //borderBottom: '2px solid #3949ab',
                      padding: '10px',
                      textAlign: 'center'   // 👈 KLJUČNO
                    }
                  }}
                >
                  {[
                    'ID',
                    'Lampa',
                    'devEUNumber',
                    'Zona',
                    'Opis',
                    'Prioritet',
                    'Status',
                    'Vrijeme alarma',
                    'Firma'
                  ].map((h) => (
                    <TableCell
                      key={h}
                      sx={{
                        color: '#ff9800',   // 🔥 OVO JE KLJUČ
                        fontWeight: 700,
                        fontSize: '13px',
                        textAlign: 'center',
                        borderBottom: '2px solid #374151',
                        backgroundColor: '#001B44'
                      }}
                    >
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredUsers.map((row) => {
                  const {
                    id,
                    devEUNumber,
                    streetlamp,
                    description,
                    priority,
                    isActive,
                    lastTriggered
                  } = row;

                  return (
                    <TableRow
                      key={id}
                      hover
                      sx={{
                        '&:hover': {
                          backgroundColor: '#001B44',
                        },
                      }}
                    >
                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>{id}</TableCell>
                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>{streetlamp.installationAddress}</TableCell>
                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>{devEUNumber}</TableCell>
                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>{streetlamp.zona.name}</TableCell>
                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>{description}</TableCell>

                      <TableCell
                        sx={{
                          textAlign: 'center',
                          color:
                            priority?.trim().toLowerCase() === 'critical'
                              ? '#ff1744'
                              : priority?.trim().toLowerCase() === 'high'
                                ? '#FFA500'
                                : priority?.trim().toLowerCase() === 'medium'
                                  ? '#ffeb3b'
                                  : priority?.trim().toLowerCase() === 'low'
                                    ? '#4CAF50'
                                    : '#ffffff',
                          fontWeight: priority?.trim().toLowerCase() === 'critical' ? 700 : 400
                        }}
                      >
                        {priority}
                      </TableCell>

                      <TableCell sx={{ textAlign: 'center', color: isActive ? '#ff1744' : '#9E9E9E' }}>
                        {isActive ? 'Aktivan' : 'Neaktivan'}
                      </TableCell>

                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>
                        {lastTriggered
                          ? new Date(lastTriggered).toLocaleString('bs-BA', {
                            timeZone: 'Europe/Sarajevo',
                            hour12: false
                          })
                          : 'N/A'}
                      </TableCell>

                      <TableCell sx={{ color: '#ff9800', textAlign: 'center' }}>
                        {streetlamp.zona.company.name}
                      </TableCell>

                    </TableRow>
                  );
                })}
              </TableBody>

            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={members.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(e, p) => setPage(p)}
            onRowsPerPageChange={(e) =>
              setRowsPerPage(parseInt(e.target.value, 10))
            }
            sx={{
              color: '#ff9800',

              '& .MuiTablePagination-selectLabel': {
                color: '#ff9800',
              },
              '& .MuiTablePagination-displayedRows': {
                color: '#ff9800',
              },
              '& .MuiSelect-icon': {
                color: '#ff9800',
              },
              '& .MuiInputBase-root': {
                color: '#ff9800',
              },
              '& .MuiIconButton-root': {
                color: '#ff9800',
              },
              '& .MuiIconButton-root.Mui-disabled': {
                color: 'rgba(255,255,255,0.3)',
              },
              '& .MuiTablePagination-selectLabel': {
                color: '#ff9800',
                marginTop: '12px'   // 👈 OVO PORAVNA
              },
              '& .MuiTablePagination-displayedRows': {
                color: '#ff9800',
                marginTop: '14px'
              },
            }}
          />
        </Card>

        {/* PDF */}
        <Box sx={{ mt: 2 }}>
          <Button
            sx={{
              minWidth: 100,
              backgroundColor: '#001B44',
              color: '#ff9800',                // 🔥 tekst orange
              border: '1px solid #ff9800',     // 🔥 border orange
              '&:hover': {
                backgroundColor: '#001B44',
                border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                color: '#ffa726'
              }
            }}
            onClick={() => setShowPDF(!showPDF)}
          >
            Generate PDF
          </Button>

          {showPDF && (
            <>
              <PDFViewer style={{ width: '100%', height: 500 }}>
                <AlarmsPDFDocument data={filteredUsers} />
              </PDFViewer>

              <Button
                sx={{
                  minWidth: 100,
                  backgroundColor: '#001B44',
                  color: '#ff9800',                // 🔥 tekst orange
                  border: '1px solid #ff9800',     // 🔥 border orange
                  '&:hover': {
                    backgroundColor: '#001B44',
                    border: '1px solid #ffa726',   // 🔥 malo svjetliji hover
                    color: '#ffa726'
                  }
                }}
              >
                Download PDF
              </Button>
            </>
          )}
        </Box>

      </Container>
    </>
  );
}